import CopyIcon from '../../../assets/copy.png'
import HTMLRenderer from '../../core/components/htmlRenderer'
import { MessageComponentProps } from '../../../types/chatbot'
import StarsBot from '../../../assets/Avatar.svg'
import ThumbsDownIcon from '../../../assets/thumbs_down.png'
import ThumbsUpIcon from '../../../assets/thumbs_up.png'
import { copyTextToClipboard } from '../../../utils/copyText'
import styles from '../styles/chatbot.module.scss'

const MessageComponent = ({
  msg,
  handleOptionButtonClick,
  handleFeedbackButtonClick
}: MessageComponentProps) => {
  const handleButtonClick = (option: string) => () =>
    handleOptionButtonClick(option)
  const copiedText = () => copyTextToClipboard(msg)

  const thumbsDownHandler = () => {
    handleFeedbackButtonClick()
  }

  return (
    <>
      {msg.sender === 'bot' && (
        <>
          <img src={StarsBot} alt='Bot Avatar' className={styles.avatar} />
          <div className={styles['message-container']}>
            <div className={styles['message-text']}>
              <HTMLRenderer htmlString={msg.text} />
            </div>
            {msg.type === 'response' && (
              <div className={styles['message-buttons']}>
                <img
                  src={ThumbsUpIcon}
                  alt='Thumbs up'
                  className={styles['message-button']}
                />
                <img
                  src={ThumbsDownIcon}
                  alt='Thumbs down'
                  className={styles['message-button']}
                  onClick={thumbsDownHandler}
                  data-testid='thumbsDownBtn'
                />
                <img
                  src={CopyIcon}
                  alt='Copy'
                  className={styles['message-button']}
                  title='copy'
                  onClick={copiedText}
                />
              </div>
            )}
            {msg.type === 'options' && msg.options && (
              <div className={styles['message-options']}>
                {msg.options.map((option, i) => (
                  <div
                    key={i}
                    className={styles['option-button']}
                    onClick={handleButtonClick(option)}
                    data-testid='optionButton'
                  >
                    {option}
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
      {msg.sender === 'user' && (
        <div className={styles['message-text']}>{msg.text}</div>
      )}
    </>
  )
}

export default MessageComponent
